// src/api/pay.js
import request from './request'


export function getPayInfo(data) {
  return request({
    url: '/pay/getPayInfo',
    method: 'post',
    data
  })
}

export function payOrder(data) {
  return request({
    url: '/pay/payOrder',
    method: 'post',
    data
  })
}

export function getOrderList(data) {
  return request({
    url: '/pay/getOrderList',
    method: 'post',
    data
  })
}
